import { Loading } from '@components/common/Loading/Loading';
import { Secured } from '@components/Secured/Secured';
import { lazy } from 'react';
import { RouteObject } from 'react-router';

import { ACTS, PATHOLOGY } from '@/constants/routes';
import { AutopsyActs } from '@/pages/Pathology/components/acts/AutopsyActs';
import { AutopsyActCard } from '@/pages/Pathology/components/card/AutopsyActCard';
import { pathology } from '@/shared/security/permissions/pathology';

const LazyPathology = lazy(() =>
  import('./PathologyPage').then((module) => ({
    default: module.PathologyPage,
  })),
);

const baseRoute: RouteObject = {
  path: PATHOLOGY,
  element: <Loading children={<LazyPathology />} />,
  children: [],
};

const pathologyRoutes = [
  {
    path: PATHOLOGY + ACTS,
    element: (
      <Secured security={{ permissions: pathology.act.viewList }}>
        <AutopsyActs />
      </Secured>
    ),
  },
  {
    path: PATHOLOGY + ACTS + '/:id',
    element: (
      <Secured security={{ permissions: pathology.act.view }}>
        <AutopsyActCard />
      </Secured>
    ),
  },
];

baseRoute.children = [...pathologyRoutes];
const routes = baseRoute.children.length > 0 ? [baseRoute] : [];

export const PathologyRoutes = routes;
